import React, { useEffect, useRef } from 'react'
import { CloseButton, ModalHeader } from '../../components/Template/Modal'
import styled, { ITheme } from '../../theme'
import useSize from '../../hooks/useSize'
import { useTranslation } from 'react-i18next'
import { ServicesModalWrapper } from '../../components/Calendar/ReservationModal'
import Flex from 'typescript-styled-flex'
import ModalFlexOverflow from '../../components/Template/Modal/ModalFlexOverflow'
import { is } from '../../components/MediaQuery'
import { useDispatch, useSelector } from 'react-redux'
import { CalendarActions } from '../../reducers/bookingCalendar/actionNames'
import { getOnbordingModalOpen } from '../../reducers/bookingCalendar/selectors/calendar'
import {
  getUserLanguage,
} from '../../reducers/userAccount/selectors/userAccount'
import Button from '../../components/Template/Button'

interface OnboardingVideoModalProps {}

const StyledButton = styled(Button)`
  margin-top: auto;
  margin-bottom: 20px;
  height: 50px;
  border-radius: 10px;
  padding-left: 50px;
  padding-right: 50px;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    margin-top: 20px;
    width: 100%;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 14px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    position: relative;
    bottom: 0;
    padding: 0 14px;
  }
`

const OnboardingVideoModal: React.FC<OnboardingVideoModalProps> = () => {
  //const [value, setValue] = React.useState(false)
  const { t } = useTranslation()
  const size = useSize()
  const ref = useRef<HTMLDivElement | null>(null)
  const [width, setWidth] = React.useState(560)
  const isDesktop = is.desktop()
  const isOpen = useSelector(getOnbordingModalOpen)
  const lang = useSelector(getUserLanguage)
  const dispatch = useDispatch()

  var VideoUrl = "https://www.youtube.com/embed/BIBGXDAwdJU"
  if (lang === 'pl' || lang === 'pl_PL') {
    VideoUrl = "https://www.youtube.com/embed/9asH6iQDTfs"
  } else if (lang === 'de') {
    VideoUrl = "https://www.youtube.com/embed/WfQXHEys-cg"
  } else if (lang === 'it') {
    VideoUrl = "https://www.youtube.com/embed/zpQLgJvcrhA"
  } else if (lang === 'es') {
    VideoUrl = "https://www.youtube.com/embed/sW0Rq1Ec39I"
  } else if (lang === 'el') {
    VideoUrl = "https://www.youtube.com/embed/2HJO9Krjh9o"
  } else if (lang === 'pt' || lang === 'pt_BR') {
    VideoUrl = "https://www.youtube.com/embed/9BcxznKwoW4"
  } else if (lang === 'fr') {
    VideoUrl = "https://www.youtube.com/embed/R-MV9yiMjro"
  } else if (lang === 'hr') {
    VideoUrl = "https://www.youtube.com/embed/aiTeDVSqZlg"
  } else if (lang === 'ru') {
    VideoUrl = "https://www.youtube.com/embed/Qe3bqspg9Wg"
  }

  const dontShowAgain = () => {
    dispatch({ type: CalendarActions.SetOnbordingShow })
  }

  const closeModal = () => {
    dispatch({ type: CalendarActions.ToggleOnbordingModal, payload: false })
  }


  const close = () => {
    dontShowAgain()
    closeModal()
  }

  useEffect(() => {
    //set with on resize
    const handleResize = () => {
      if (ref.current) {
        setWidth(ref.current.getBoundingClientRect().width)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current])

  return (
    <ModalFlexOverflow open={isOpen} onClose={close}>
      <ServicesModalWrapper>
        <ModalHeader
          style={{
            padding: `${size}em ${0.2 * size}em 0px ${0.5 * size}em`,
            paddingLeft: '15px',
          }}
        >
          <Flex
            style={{ width: '100%' }}
            justifyEnd={true}
            alignCenter={true}
          >
            <CloseButton data-cy={'onboarding-close-button'} onClose={close} />
          </Flex>
        </ModalHeader>

        <Flex
          ref={ref}
          column={true}
          style={{
            fontSize: `${16 * size}px`,
            padding: `15px`,
          }}
        >
          <iframe
            width={isDesktop ? '560' : width - 30}
            height={isDesktop ? '315' : (width - 30) / 1.777}
            src={VideoUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Flex>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              fontWeight: "bold",
              fontSize: "22px",              
              paddingBottom: '10px'
            }}>
              <p style={{ maxWidth: '80%', padding: '0px', margin: '0px', lineHeight: '28px', textAlign: 'center'}}>
              {t('BED_modal_video_txt1')}
              </p>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              fontSize: "16px",     
              fontWeight: 500,                                     
            }}>
              <p style={{ maxWidth: '80%', padding: '0px', margin: '0px', lineHeight: '28px', textAlign: 'center'}}>
              {t('BED_modal_video_txt2')}
              </p>
              </div>
        <ButtonWrapper>
          <div style={{ }}>
          <StyledButton
            onClick={close}
            primary={true}
          >
            {t('BED_modal_video_button_txt')}
          </StyledButton>
          </div>
        </ButtonWrapper>            
      </ServicesModalWrapper>
    </ModalFlexOverflow>
  )
}

export default OnboardingVideoModal
